import { FORM_TOKEN_NODE_KEY_SEPARATOR } from '../../constants';
import { TokenId } from '../../types/context';

export const getFormTokenMetaKey = (storageKey: string, metaId: TokenId) =>
  `${storageKey}${FORM_TOKEN_NODE_KEY_SEPARATOR}${metaId}`;
